import React, { useEffect, useState } from "react";
import Button from "../Button";
import Modal from "../Modal";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { createStatusOptions } from "../../helpers/selects";
import InputSelect from "../InputSelect";


export const ModalEditStatus = ({action, close, show, loading, text, type}) => {
    const [statuses, setStatuses] = useState([]);
    const [loadingStatuses, setLoadingStatuses] = useState(true);
    const [statusToApply, setStatusToApply] = useState(null);

    useEffect(() => {
        if(show) {
            setStatusToApply(null);
            setLoadingStatuses(true);
            let filter = type ? `?filters[0][type][equal]=${type}` : '';

            api.get(`/status${filter}`).then(res => {
                setStatuses(res.data.resources);
            }).catch(error => {
                renderError(error);
            }).then(() => {
                setLoadingStatuses(false);
            });
        }
    }, [type, show]);

    const handleConfirm = () => {
        if(statusToApply) {
            action(statusToApply);
        }
    };

    return (
        <Modal 
            show={show}
            title={`Edição de status`}
            close={close}
            footer={
                <>
                    <Button type={`primary`} size={`small`} svg={`save-white`} text={`Confirmar`} action={handleConfirm} loading={loading} disabled={!statusToApply}/>
                    {!loading &&
                        <Button type={`secondary`} size={`small`} text={`Cancelar`} action={close}/>
                    }
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col">
                        <InputSelect 
                            label={`Status *`} 
                            value={statusToApply} 
                            change={setStatusToApply} 
                            options={createStatusOptions(statuses)} 
                            loading={loadingStatuses}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}